var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 740,
    viewBox: "0 0 740 740",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 370C0 165.638 165.659 0 370 0C574.341 0 740 165.638 740 370C740 574.341 574.341 740 370 740C165.659 740 0 574.341 0 370ZM142 371.01C142 497.477 244.528 600 371 600C497.472 600 600 497.477 600 371.01C600 346.231 596.072 322.329 588.78 299.974L371 370.99V142C244.528 142 142 244.523 142 371.01Z",
    fill: "#4357AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.35cc7ecfd828d0df58246749db4a464f.svg";
export { ForwardRef as ReactComponent };